(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBeforeAfter(root) {
    if (!root || root.dataset.baInit === '1') return;
    root.dataset.baInit = '1';

    var range = root.querySelector('.before-after__range');
    if (!range) return;

    function setPosition(value) {
      var clamped = Math.max(0, Math.min(100, parseFloat(value) || 0));
      root.style.setProperty('--ba-position', clamped + '%');
      range.setAttribute('aria-valuenow', clamped.toFixed(1));
    }

    setPosition(range.value);

    range.addEventListener('input', function () {
      setPosition(range.value);
    });

    // Click on the frame jumps the slider to that point
    var frame = root.querySelector('.before-after__frame');
    if (frame) {
      frame.addEventListener('click', function (e) {
        if (e.target === range) return;
        if (e.target.closest && e.target.closest('.before-after__overlay')) return;
        var rect = frame.getBoundingClientRect();
        var vertical = root.dataset.orientation === 'vertical';
        var pct = vertical
          ? ((e.clientY - rect.top) / rect.height) * 100
          : ((e.clientX - rect.left) / rect.width) * 100;
        range.value = pct;
        setPosition(pct);
      });
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.before-after');
    nodes.forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-images"] && !Shopify.designMode) return;
  try {
    
(function () {
  var badges = [];

  function collectBadges(scope) {
    var nodes = (scope || document).querySelectorAll('.split-images__badge--rotate-on-scroll');
    nodes.forEach(function (badge) {
      if (badge.dataset.siBadgeInit === '1') return;
      badge.dataset.siBadgeInit = '1';
      var svg = badge.querySelector('.split-images__badge-svg');
      if (svg) badges.push(svg);
    });
  }

  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    for (var i = 0; i < badges.length; i++) {
      badges[i].style.transform = 'rotate(' + (y * 0.2) + 'deg)';
    }
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }

  function init(scope) {
    collectBadges(scope);
    if (badges.length) update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
